<template>
    <svg :class="['svg--' + name]" :style="{ fill: '#' + getFill }">
        <use :xlink:href="static('svg/sprite.symbol.svg#' + name)" />
    </svg>
</template>

<script>
export default {
    name: "SvgView",
    props: {
        name: String,
        getFill: { type: String, default: '' },
    },
};
</script>
